<template>
  <div class="bg-gray">
    <div class="form-content">
    <el-alert
    :closable="false"
    title="裁判长申报联系人： 寇磊 18551717417"
    type="warning">
  </el-alert>
      <el-form
        :model="formData"
        ref="ruleForm"
        :rules="rules"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-divider>赛事信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="赛事名称"
              prop="saiqu_name"
              :rules="[
                { required: true, message: '请输入赛事名称', trigger: 'blur' },
              ]"
            >
              <el-input
                v-model="formData.saiqu_name"
                type="text"
                placeholder="请输入赛事名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="竞赛规程文件/补充通知"
              prop="files" 
              :rules="[
                { required: true, message: '请选择', trigger: 'blur' },
              ]"
            >
              <FileUploader uploadText="上传文件" :fileList="formData.files" :limit="2" accept=".doc,.pdf,.docx"
                                  :name="'files'"></FileUploader>
            </el-form-item>
            
            <div class="form-label-desc"  >【含收费情况、比赛时间和地点】（上传word或pdf）</div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="拟担任裁判情况"
              prop="cptype"
              :rules="[
                {
                  required: true,
                  message: '请选择',
                  trigger: 'blur',
                },
              ]"
            > 
            <el-radio v-model="formData.cptype" label="裁判长">裁判长</el-radio>
            <el-radio v-model="formData.cptype" label="高级裁判组组长">高级裁判组组长</el-radio>
            <br/>只有担任裁判长或高级裁判组组长才需要报备，一般打分裁判员无需报备。
            </el-form-item>
          </el-col>
          <el-col :span="12"> 
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="举办时间"
              prop="date_range"
              :rules="[
                {
                  required: true,
                  message: '请输入举办时间',
                  trigger: 'blur',
                },
              ]"
            >
            <el-date-picker
              v-model="formData.date_range"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right" 
              placeholder="选择日期" >
            </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12"> 
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="举办地点"
              prop="area"
              :rules="[
                {
                  required: true,
                  message: '请选择举办地点',
                  trigger: 'blur',
                },
              ]"
            >
              <el-cascader
                v-model="formData.area"
                ref="areas"
                @change="handleAreasChange"
                :options="areaOptions"
                :props="{ label: 'title' }"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="详细地址"
              prop="address"
            >
              <el-input
                type="text"
                placeholder="请输入详细地址"
                v-model="formData.address"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>



        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="主办单位"
              prop="zb"
              :rules="[
                {
                  required: true,
                  message: '请填写主办单位',
                  trigger: 'blur',
                },
              ]"
            > 
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请填写主办单位"
                v-model="formData.zb"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="承办单位"
              prop="cb"
              :rules="[
                {
                  required: true,
                  message: '请填写承办单位',
                  trigger: 'blur',
                },
              ]"
            > 
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请填写承办单位"
                v-model="formData.cb"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="协办单位"
              prop="xb"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请填写协办单位"
                v-model="formData.xb"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"> 
          </el-col>
        </el-row>


        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="参赛费收费标准"
              prop="sai_price"
              :rules="[
                {
                  required: true,
                  message: '请填写参赛费收费标准',
                  trigger: 'blur',
                },
              ]"
            > 
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请填写参赛费收费标准"
                v-model="formData.sai_price"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"> 
            <el-form-item
              label="食宿费收费标准"
              prop="shisu_price"
              :rules="[
                {
                  required: true,
                  message: '请填写食宿费收费标准',
                  trigger: 'blur',
                },
              ]"
            > 
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请填写食宿费收费标准"
                v-model="formData.shisu_price"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="公安机关报备"
              prop="police_report"
              :rules="[
                {
                  required: true,
                  message: '请选择',
                  trigger: 'blur',
                },
              ]"
            > 
             <el-radio v-model="formData.police_report" :label="1">是</el-radio>
              <el-radio v-model="formData.police_report" :label="2">否</el-radio>
            <div>赛事是否已与县级及以上公安机关报备。<br/>必须向公安机关报备才能申请通过。</div>
            </el-form-item>
          </el-col>
          <el-col :span="12"> 
            <el-form-item
              label="购买责任险"
              prop="is_baoxian"
              :rules="[
                {
                  required: true,
                  message: '请选择',
                  trigger: 'blur',
                },
              ]"
            > 
             <el-radio v-model="formData.is_baoxian" :label="1">是</el-radio>
              <el-radio v-model="formData.is_baoxian" :label="2">否</el-radio>
            <div>是否已购买赛事公众责任险。<br/>必须购买赛事公众责任险才能申请通过。</div>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row :gutter="20" v-if="false">
          <el-col :span="20">
            <el-form-item
              label="赛事简介"
              prop="content"
              :rules="[
                {
                  required: true,
                  message: '请输入赛事简介',
                  trigger: 'blur',
                },
              ]"
            > 
            <el-input
  type="textarea"
  :autosize="{ minRows: 2, maxRows: 4}"
  placeholder="请输入内容"
  v-model="formData.content">
</el-input>
    
            <!-- <UEditor
              ref="ue"
              style="width: 600px; height: 520px"
              :ueditorContent.sync="formData.content"
            ></UEditor> -->
            </el-form-item>
          </el-col> 
        </el-row>

        <el-divider>总裁判长个人信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="姓名"
              prop="name"
              :rules="[
                { required: true, message: '请输入姓名', trigger: 'blur' },
              ]"
            >
              <el-input
                v-model="formData.name"
                type="text"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="证件号"
              prop="num" 
              :rules="[
                { required: true, message: '请输入证件号', trigger: 'blur' },  
              ]" 
            >
              <el-select 
                  style="width:100px !important"
                  placeholder="请选择证件类型"  
                  v-model="formData.cardtype"
              >
                <el-option 
                    :key="1"
                    label="身份证"
                    :value="1"
                >
                </el-option>
                <el-option 
                    :key="2"
                    label="护照"
                    :value="2"
                >
                </el-option>  
                <el-option 
                    :key="3"
                    label="其他"
                    :value="3"
                >
                </el-option>  
              </el-select>
              <el-input
                v-model.trim="formData.num"
                type="text"
                @blur="getCaipanGrade"
                v-if="formData.cardtype==1"
                placeholder="请输入身份证号"
              ></el-input>
              <el-input
                v-else
                v-model.trim="formData.num"
                @blur="getCaipanGrade"
                type="text"
                placeholder="请输入证件号"
              ></el-input>
            </el-form-item>
             
          </el-col> 
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="申报人微信"
              prop="weixin"
              :rules="[
                {
                  required: true,
                  message: '请输入申报人微信',
                  trigger: 'blur',
                },
              ]"
            > 
              <el-input
                v-model="formData.weixin"
                type="text"
                placeholder="请输入申报人微信"
              ></el-input>
            </el-form-item>
          </el-col> 
          <el-col :span="12">
            <el-form-item
              label="申报人邮箱"
              prop="email"
              :rules="[
                {
                  required: true,
                  message: '请输入申报人邮箱',
                  trigger: 'blur',
                }, 
                { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
              ]"
            > 
              <el-input
                v-model="formData.email"
                type="text"
                placeholder="请输入申报人邮箱"
              ></el-input>
            </el-form-item>
          </el-col> 
        </el-row>
        
        

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="手机号"
              prop="phone"
              :rules="[
                { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validator.phone, message: '请输入正确的手机号' },
              ]"
            >
              <el-input
                v-model="formData.phone"
                type="text"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="验证码"
              prop="phonecode"
              :rules="[
                {
                  required: true,
                  message: '请输入验证码',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                style="width:160px"
                v-model="formData.phonecode"
                placeholder="请输入验证码"
              ></el-input>
              <el-button @click="getCode"  size="small" type="primary" :disabled="clockSecond>0">{{clockSecond>0?
                    '('+clockSecond+'s)':'获取验证码'}}</el-button>
            </el-form-item>
          </el-col> 
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="裁判证编号"
              prop="cert_no"
              :rules="[
                {
                  required: true,
                  message: '请输入裁判证编号',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="formData.cert_no"
                placeholder="请输入裁判证编号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="裁判等级"
              prop="cert_grade"
              :rules="[
                {
                  required: true,
                  message: '请选择裁判等级',
                  trigger: 'blur',
                },
              ]"
            >  
              <el-select
                  placeholder="请选择裁判等级"  
                  v-model="formData.cert_grade"
              >
                <el-option 
                    :key="1"
                    label="国际级"
                    value="国际级"
                >
                </el-option>
                <el-option 
                    :key="2"
                    label="国家级"
                    value="国家级"
                >
                </el-option>
                <!-- <el-option 
                    :key="3"
                    label="一级"
                    value="一级"
                >
                </el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="工作单位"
              prop="danwei"
              :rules="[
                {
                  required: true,
                  message: '请输入工作单位',
                  trigger: 'blur',
                },
              ]"
            > 
              <el-input
                v-model="formData.danwei"
                type="text"
                placeholder="请输入工作单位"
              ></el-input>
            </el-form-item>
          </el-col> 
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="承诺"
              prop="comfirm"
              :rules="[
                {
                  required: true,
                  message: '请勾选承诺',
                  trigger: 'blur',
                },
              ]"
            >   
              <el-checkbox v-model="formData.comfirm">我承诺赛事期间向参赛代表队投放满意度调查报告，并于5日内回传成绩册、赛事总结报告。</el-checkbox>
            </el-form-item>
          </el-col> 
        </el-row>
        <el-row>
          <el-col class="footer-button">
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              :loading="saveLoading"
              >提交
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>

      <LoginDialog
        :show="loginShow"
        @loginSuccess="loginSuccess"
        @loginCancel="loginCancel"
      />
    </div>
  </div>
</template>
<style scoped>
.box {
  width: 100%;
  margin: 0 auto;
}
.form {
  width: 1340px;
  min-height: 560px;
  background: #ffffff;
  padding-top: 24px;
  padding: 88px 0 30px 129px;
  box-sizing: border-box;
}
.savebtn {
  margin-top: 40px;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}
</style>
<script>
import Vue from "vue";
import validator from "../../../utils/validator";
import FileUploader from '@/components/picker/FileUploader.vue';
import PicUploader from "@/components/picker/PicUploader.vue";

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Dialog,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
} from "vant";
import CaipanPicker from "@/components/picker/CaipanPicker.vue";
import JiaolianPicker from "@/components/picker/JiaolianPicker.vue";
import LoginDialog from "@/components/LoginDialog.vue"; 
// import UEditor from "@/components/UEditor/";

Vue.use(Cell)
  .use(CellGroup)
  .use(Form)
  .use(Divider)
  .use(Area)
  .use(RadioGroup)
  .use(Dialog)
  .use(Radio)
  .use(Icon)
  .use(Toast)
  .use(Popup)
  .use(Picker)
  .use(Sidebar)
  .use(SidebarItem)
  .use(Tag)
  .use(Stepper)
  .use(Field)
  .use(Switch)
  .use(Button);
export default {
  name: "HuiyiApplyFormStep1",
  components: {
    [Field.name]: Field,
    PicUploader,
    CaipanPicker,
    JiaolianPicker,
    LoginDialog,
    FileUploader,
    // UEditor,
  },
  data: function () {
    return {
      validator,
      arr: [],
      areaOptions: [],
      loginShow: false,
      saveLoading: false,
      saiqu_id: this.$route.query.saiqu_id,
      numTypeColumns: ["身份证", "护照"],
      showArea: false,
      areaList: {},
      areaValue: "",
      clockSecond:0,
      submitType: "",
      formData: {
        id: 0,
        area: "", 
        cptype:'',
        areas: [],
        date_range:[],
        date:'',
        content:'',
        name:'',
        email:'',
        weixin:'',
        num:'',
        sai_price:'',
        shisu_price:'',
        cert_no:'',
        zb:'',
        cb:'',
        xb:"",
        police_report:'',
        is_baoxian:'',
        cert_grade:'',
        cardtype:1,
        eareas: [],
        saiqu_name: "",
        danwei: "",
        ldname: "",
        weixin: "",
        phone: "",
        files:[], 
        province: "",
        city: "",
        county: "",
        eprovince: "",
        ecity: "",
        ecounty: "",
        address: "",
      },
      rules: { 
      },
    };
  },
  filters: {},
  mounted() {
    let that = this;
    that.formData.id = this.$route.query.id;
    document.title = "联系人信息";
    if(that.formData.id>0){
      this.fetch();
    }
    this.getAreaOptions();
  },
  watch: {
    formData() {},
  },
  destroyed() {},
  methods: {
    getCode() {
        let that = this;
        if (that.clockSecond > 0) {
            return;
        }
        if (!that.formData.phone) {
            Toast('请输入手机号')
            return;
        }
        /*if (!that.formData.code) {
            Toast('请输入验证码')
            return;
        }*/
        that.$api.get('/api/index/phonecode', {phone: that.formData.phone}, (res) => {
            Toast(res.msg);
        })

        that.clockSecond = 60;

        var t = setInterval(function () {
            if (that.clockSecond > 0) {
                that.clockSecond = that.clockSecond - 1;
            } else {
                clearInterval(t);
            }
        }, 1000)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleChange(val) {
      console.log(val);
      for (var i = 0; i < this.arr.length; i++) {
        if (this.arr[i].value == val[0]) {
          this.formData.city = this.arr[i].title;
        }
        if (this.arr[i].value == val[1]) {
          this.formData.county = this.arr[i].title;
        }
        if (this.arr[i].value == val[2]) {
          this.formData.province = this.arr[i].title;
        }
      }
      this.formData.area = val[2];
    },
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (res) => {
        that.areaOptions = res.data;
        that.namekeyList = res.data;
      });
    },
    handleAreasChange(values) {
      let data = this.$refs.areas.getCheckedNodes()[0].pathLabels;
      console.log("handleAreasChange", values, data);
      this.formData.area = values[2];
      this.formData.province = data[0];
      this.formData.city = data[1];
      this.formData.county = data[2];
    }, 
    fetch() {
      let that = this;
      that.$api.get(
        "/api/cpz/applyDetail",
        { 
          id: that.formData.id,
        },
        (res) => { 
          that.formData = Object.assign(that.formData, res.data);
          that.formData.date_range = [that.formData.date, that.formData.date_end];
          console.log("Dialog"); 
        },
        (res) => {
          console.log("没有登录");
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    onQuestion() {
      console.log("onQuestion");
    },
    jumToOld(id) {
      rbLink(
        {
          name: "HuiyiApplyList",
        },
        "replace"
      );
    },
    getCaipanGrade(){
      let that = this
      if(that.formData.num){
          that.$api.post(
            "/api/cha/caipangrade",
            {
              num:that.formData.num
            },
            (res) => { 
              console.log('caipan grade',res)
              if(res.success){
                that.formData.cert_grade = res.data.grade
                that.formData.cert_no = res.data.code
              }
            },
            (res) => { 
            }
          );
      }
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      console.log(that.formData, that.$refs[formName]);
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          console.log(that.formData);
          that.formValidate = true;
          for (let field in that.formData) {
            if (!this.formData.areas) {
              that.$message.warning("请选择地区");
              return;
            }
          }
          that.saveLoading = true;
          that.formData.date = that.formData.date_range[0];
          that.formData.date_end = that.formData.date_range[1];
          that.$api.post(
            "/api/cpz/apply",
            that.formData,
            (res) => {
              that.saveLoading = false;
               that.$message.success('提交成功')
               rbLink(
                {
                  name: "CpzApplyList",
                },'back')
            },
            (res) => {
              this.$message.warning(res.msg);
              that.saveLoading = false;
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
    submit(values) {
      this.submitType = "submit";
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// CpzApplyFormStep1.vue?35625258